import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  catalogCategoryAdapter,
  catalogProductAdapter,
  catalogSubcategoryAdapter,
  orderAdapter,
  selectAllRepeatOrderBulk,
  selectAllRepeatOrderGeneralCargo,
} from './reducer';
import { AppState, BannerNotificationState } from '../models/app.models';
import { CatalogItem } from '../models/catalog-item.model';

const orderSelectors = orderAdapter.getSelectors();
const catalogCategorySelectors = catalogCategoryAdapter.getSelectors();
const catalogProductSelectors = catalogProductAdapter.getSelectors();
const catalogSubcategorySelectors = catalogSubcategoryAdapter.getSelectors();

export const selectAppState = createFeatureSelector<AppState>('app');

export const selectBannerState = createFeatureSelector<BannerNotificationState>('banner-notification');

export const selectBannerNotificationVisibility = createSelector(selectBannerState, (state) => state.bannerNotificationVisible);

export const selectOrdersState = createSelector(selectAppState, (state) => state?.orders);

export const selectOrders = createSelector(selectOrdersState, orderSelectors.selectAll);

export const selectOrderDetails = createSelector(selectAppState, (state) => state?.orderDetails);

export const selectCatalogCategoriesState = createSelector(selectAppState, (state) => state?.catalogCategories);

export const selectCatalogCategories = createSelector(selectCatalogCategoriesState, catalogCategorySelectors.selectAll);

export const selectCatalogProductsState = createSelector(selectAppState, (state) => state?.catalogProducts);

export const selectCatalogProducts = createSelector(selectCatalogProductsState, catalogProductSelectors.selectAll);

export const selectSelectedCatalogCategory = createSelector(selectAppState, (state) => state?.selectedCatalogCategory);

export const selectCatalogSubcategoriesState = createSelector(selectAppState, (state) => state?.catalogSubcategories);

export const selectCatalogProductSearchString = createSelector(selectAppState, (state) => state?.catalogProductSearchString);

export const selectCatalogSortMode = createSelector(selectAppState, (state) => state?.catalogSortMode);

export const selectcatalogTotalNumberOfProductsFound = createSelector(selectAppState, (state) => state?.catalogTotalNumberOfProductsFound);

export const selectCatalogSubcategories = createSelector(selectCatalogSubcategoriesState, catalogSubcategorySelectors.selectAll);

export const selectCategoryById = (categoryId: string) =>
  createSelector(selectCatalogCategories, (categories: CatalogItem[]) => categories.find((c) => c.entryId === categoryId));

export const selectRepeatOrder = createSelector(selectAllRepeatOrderBulk, selectAllRepeatOrderGeneralCargo, (bulk, generalCargo) => ({ bulk, generalCargo }));
